import { countryListApi } from "../../api/country/countryListApi"
import { Country } from "../../entities/country"

type PayloadShape = Parameters<typeof countryListApi>[0]

export async function countryListService(payload: PayloadShape, token?: null | string) {
	const country = await countryListApi(payload, token)
	return country as NonNullable<Country[]>
}
